import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center py-2", className)}
    {...props}>
    <SliderPrimitive.Track
      className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-[hsl(240,4%,18%)]">
      <SliderPrimitive.Range className="absolute h-full bg-[hsl(350,58%,42%)]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      className="block h-6 w-6 rounded-full border-[3px] border-[hsl(240,6%,7%)] bg-[hsl(350,58%,42%)] shadow-[0_0_12px_hsla(350,58%,42%,0.4)] transition-shadow focus-visible:outline-none focus-visible:shadow-[0_0_0_4px_hsla(350,58%,42%,0.2),0_0_12px_hsla(350,58%,42%,0.4)] hover:shadow-[0_0_18px_hsla(350,58%,42%,0.55)] cursor-grab active:cursor-grabbing" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
